import React, { ReactNode } from "react";
import { Navigate } from 'react-router-dom';

const Pages = React.lazy(() => import("../pages/convergence/convergence-index"));
const PageNotFound = React.lazy(() => import("../pages/errors/page-not-found"));

export type route = {
  component: ReactNode;
  path: string;
  routes?: route[];
  [propName: string]: any;
};

const Routes: route[] = [
  { path: '/', exact: true, name: 'Convergence 2026 Home', component: <Navigate to={`/convergence/home${window.location.search}`} replace /> },
  { path: '/*', exact: true, name: 'Convergence 2026 All', component: <Pages /> },

  { path: '/*', exact: true, component: <PageNotFound /> },
]

export default Routes;